export default {
  getCardType(cardNumber) {
    if (cardNumber.charAt(0) === '4') {
      return 'Visa';
    }
    if (cardNumber.charAt(0) === '5') {
      return 'Mastercard';
    }
    if (cardNumber.charAt(0) === '6') {
      return 'Discover';
    }
    return 'VisaElectron';
  }
}



// WEBPACK FOOTER //
// ./src/services/UtilService.js